import React, {useState} from 'react';
import AddCard from '../Billing/AddCard';
import Alert from '../../Components/Alert';
import { usePreference } from '../../Data/Preference';
import { useBalance } from '../../Data/Balance';
import { useSession } from '../../Components/Session';
import Modal from '../../Components/Modal';
import Button from '../../Components/Button/Button';
import Form, { Actions } from '../../Components/Form';
import { Money } from '@/Components/Primitives';

const PendingVoucher = ({onComplete}) => {
    const [paymentClosed, setPaymentClosed] = usePreference('pendingVoucher:payment:closed', false, true);
    const [confirmClosed, setConfirmClosed] = usePreference('pendingVoucher:confirm:closed', false, true);
    const [redeemed, setRedeemed] = useState(false);
    const {balance} = useSession();
    const {redeemVoucher} = useBalance();

    const unclose = () => {
        setPaymentClosed(false);
        setConfirmClosed(false);
    }

    const handleRedeem = async () => {
        await redeemVoucher(balance.pendingVoucher.voucherCode);
        setRedeemed(true);
        await onComplete();
        setPaymentClosed(true);
        setConfirmClosed(true);
    }

    if (!balance?.pendingVoucher) {
        return null;
    }

    const panel = <Alert type="info"
        icon="Gift"
        title="Unused voucher"
        message={
            `You've not yet claimed your voucher.\nPlease complete your payment details before it expires.`
        }
        onClick={unclose}
        buttons={[
            <Button theme="primary" label="Complete" onClick={unclose} />
        ]}
    />

    if (!balance.paymentMethod) {
        return <>
            {panel}
            <AddCard isOpen={!paymentClosed} setIsOpen={() => setPaymentClosed(true)} onComplete={onComplete} />
        </>
    }

    if (balance.pendingVoucher) {
        return <>
            {panel}
            <Modal title="Redeem voucher" isOpen={!confirmClosed} setIsOpen={() => setConfirmClosed(true)} dismissible>
                <Form onSubmit={handleRedeem}>
                    <div className="prose surface-1">
                        {redeemed === false && <p>
                            Would you like to purchase {balance.pendingVoucher.voucherDetails.planCredits} months of Soapy Plus for <Money pence={balance.pendingVoucher.voucherDetails.cost} />?
                        </p>}
                        {redeemed === true && <p className="font-bold">
                            Your voucher has been redeemed!
                        </p>}
                    </div>

                    <Actions submit={{label: 'Confirm'}}
                        cancel={{label: 'Later'}}
                    />
                </Form>
            </Modal>
        </>
    }

    return panel;
}

export default PendingVoucher;
